export default "__VITE_ASSET__BX2HXUd8__"